import { css } from 'styled-components';
import {
  getTypography, TypographyName, getSpacing, SpacingName, ThemedFunctor,
} from '@doveit/lego';

export const link: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.SMALLER)}
  ${getSpacing.marginTop(theme, SpacingName.SMALLER)}
  color: ${theme.palettes.neutrals.darkest};
  text-decoration: none;
  display: block;
`;
